import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import PageNavBar from "layout/PageNavBar";
import PageFooter from "layout/PageFooter";
import FileDownloadListener from "components/FileDownloadListener";
import { useUser } from "query/user.query";
import { initAppcue } from "utils/appcues";
import { datadogRum } from "@datadog/browser-rum";
import { CommunityBanner } from "components/CommunityBanner";
import { USER_TYPES } from "api/api.typing";

function MainLayout() {
  const { data: user } = useUser();
  // banner should not appear for Customer reviewers
  const isShouldDisplayBanner = user?.userType !== USER_TYPES.customer;

  useEffect(() => {
    if (user) {
      initAppcue(user);
      datadogRum.setUser({ email: user.email });
    }
  }, [user]);

  return (
    <div className="flex h-full flex-col">
      <PageNavBar />
      {isShouldDisplayBanner && <CommunityBanner />}
      <main className="flex-1 border-y border-slate-200 bg-gray-100 dark:border-slate-600 dark:bg-gray-700">
        <div className="">
          <Outlet />
          <FileDownloadListener />
        </div>
      </main>
      <PageFooter />
    </div>
  );
}

export default MainLayout;
